import { useGatewaySession } from "@/hooks/useSession";

/**
 * Identity seam: the gateway session identity from /oauth/userinfo, shaped so
 * every consumer reads the same field paths (user.fullName,
 * user.primaryEmailAddress.emailAddress, user.publicMetadata.accountId, ...).
 */
export function useUser() {
  return useGatewaySession();
}
